import * as React from "react"

export default function IconBluesky({ fill }) {
  return (
    <svg
      width="39"
      height="35"
      viewBox="0 0 39.3 34.6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.52,2.33c4.51,3.38,9.35,10.24,11.13,13.92,1.78-3.68,6.63-10.54,11.13-13.92,3.25-2.44,8.52-4.33,8.52,1.68,0,1.2-.69,10.08-1.09,11.52-1.4,5.01-6.51,6.29-11.06,5.52,7.95,1.35,9.97,5.83,5.6,10.31-8.29,8.51-11.92-2.14-12.85-4.86-.17-.5-.25-.73-.25-.54,0-.2-.08.04-.25.54-.93,2.73-4.56,13.37-12.85,4.86-4.37-4.48-2.34-8.96,5.6-10.31-4.55.77-9.66-.5-11.06-5.52-.4-1.44-1.09-10.32-1.09-11.52C0-2,5.27-.11,8.52,2.33h0Z"
        fill={fill}
      />
    </svg>
  )
}